import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export const getKnowledgebasePage = async (pageId) => {
  const url = `${backendUrl}/api/knowledgebase/page/${pageId}/`;
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  };

  try {
    const response = await fetchWithAuth(url, options);

    if (!response.ok) {
      throw new Error(
        `Сетевая ошибка при получении страницы базы знаний: HTTP error! Status: ${response.status}`
      );
    }

    return await response.json();
  } catch (error) {
    console.error('Программная ошибка при получении страницы базы знаний:', error);
    throw error;
  }
};